import Content from "./Content";

export default class ChatMessageContent extends Content {
    constructor(languagePack, contentID, text, shortText, label) {
        super(ChatMessageContent.NAME, ChatMessageContent.TYPE, label, languagePack, contentID);

        this.setText(text);
        this.setShortText(shortText);
    }

    setText(value) {
        if (this.getText() !== value) {
            this.setLanguagePackText(ChatMessageContent.TEXT_LABEL, value);
        }
    }

    getText() {
        return this.getLanguagePackText(ChatMessageContent.TEXT_LABEL);
    }

    setShortText(value) {
        if (this.getShortText() !== value) {
            this.setLanguagePackText(ChatMessageContent.SHORT_TEXT_LABEL, value);
        }
    }

    getShortText() {
        return this.getLanguagePackText(ChatMessageContent.SHORT_TEXT_LABEL);
    }

    setBalloonType(value) {
        this._balloonType = value;
    }

    getBalloonType() {
        return this._balloonType;
    }

    convertToObject() {
        return this.getObject([]);
    }
}

ChatMessageContent.NAME = "Chat Message";
ChatMessageContent.TYPE = "engChatMessageContent";
ChatMessageContent.TEXT_LABEL = "text";
ChatMessageContent.SHORT_TEXT_LABEL = "shortText";
